import React, { useCallback, useMemo } from "react";
import { Locale, MessageID } from "../../i18n/types";
import { DropdownSelectionOption } from "../DropdownSelection/models";
import { useI18n } from "../../i18n";
import DropdownSelection from "../DropdownSelection";
import dropdownIcon from "../../assets/locale-selection-button-icon.svg";

import styles from "./LocaleSelection.module.scss";

const LocaleMessageId: Record<Locale, MessageID> = {
  [Locale.en]: "view.topBar.localeSelection.enUS",
  [Locale.zhHant]: "view.topBar.localeSelection.zhHant",
};

interface LocaleSelectionProps {
  locale: string | null;
  onLocaleSelected: (locale: string) => void;
  disabled?: boolean;
}

const LocaleSelection: React.FC<LocaleSelectionProps> = props => {
  const { locale, onLocaleSelected, disabled } = props;
  const { translate } = useI18n();

  const localeOptions = useMemo<DropdownSelectionOption[]>(() => {
    const options: DropdownSelectionOption[] = Object.values(Locale).map(
      loc => {
        return {
          value: loc,
          name: translate(LocaleMessageId[loc]),
        };
      }
    );
    return options;
  }, [translate]);

  const onOptionSelected = useCallback(
    (option: DropdownSelectionOption) => {
      if (option.value) {
        onLocaleSelected(option.value);
      }
    },
    [onLocaleSelected]
  );

  return (
    <DropdownSelection
      buttonClassName={styles.dropdownButton}
      buttonIcon={
        <img
          className={styles.dropdownButtonIcon}
          src={dropdownIcon}
          alt={"locale-dropdown-icon"}
        />
      }
      menuAnchorClassName={styles.dropdownAnchor}
      options={localeOptions}
      onOptionSelected={onOptionSelected}
      selectedOptionValue={locale}
      disabled={disabled}
    />
  );
};

export default LocaleSelection;
